<div class="wrapper m-a">
  <!-- Label -->
  <div class="bold-700 text-10 pb-2">
    @if (labelIcon) {
      <shared-icon class="mx-1" [icon]="labelIcon" height="0.75rem" width="0.75rem" />
    }
    @if (label) {
      {{ label }}
    }
  </div>

  <!-- Ticket -->
  <div class="ticket-container m-a color-dark">
    <div class="text-center" topPart>
      <img class="img" [src]="image" alt="" />
    </div>
    <div class="w-100 px-4 layout-fr-auto align-items-center" bottomPart>
      <div class="text-10 text-start">{{ valueLabel }}</div>
      <div class="text-24">{{ value | currency: "GBP" : "symbol" : "1.0-0" }}/month</div>
    </div>
  </div>
</div>
